import { render, staticRenderFns } from "./wayTestB.vue?vue&type=template&id=5b8ea464&scoped=true&"
import script from "./wayTestB.vue?vue&type=script&lang=js&"
export * from "./wayTestB.vue?vue&type=script&lang=js&"
import style0 from "./wayTestB.vue?vue&type=style&index=0&id=5b8ea464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ea464",
  null
  
)

export default component.exports